import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cartao'
})
export class CartaoPipe implements PipeTransform {

  transform(numero: any, args?: any): any {
    if (numero) {
      let blind = '';

      if (numero.length > 19) {
        blind = '*** *** *** *** *** *** *** ';
      } else {
        blind = '*** *** *** ';
      }
      numero = blind + numero.substring(numero.length - 7, numero.length);
    }
    return numero;
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/cartao.pipe.ts